export default __webpack_public_path__ + "static/media/office2-afterB-1920w.653dae54.png";